<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="20" style="text-align: left;display: flex;align-items: center;">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item label="分类：" size="medium">
                            <el-badge :value="count0" style="margin-right: 25px;" :max="99" :hidden="form.custPageType == 0||count0==0">
                                <el-button size="mini" :class="{'selected':form.custPageType == 0}" @click="handleSearchType(0)">全部</el-button>
                            </el-badge>
                            <el-badge :value="count1" style="margin-right: 25px;" :max="99" :hidden="form.custPageType == 1||count1==0">
                                <el-button size="mini" :class="{'selected':form.custPageType == 1}" @click="handleSearchType(1)">未注册</el-button>
                            </el-badge>
                            <el-badge :value="count2" style="margin-right: 25px;" :max="99" :hidden="form.custPageType == 2||count2==0">
                                <el-button size="mini" :class="{'selected':form.custPageType == 2}" @click="handleSearchType(2)">已注册</el-button>
                            </el-badge>
                            <el-badge :value="count3" style="margin-right: 25px;" :max="99" :hidden="form.custPageType == 3||count3==0">
                                <el-button size="mini" :class="{'selected':form.custPageType == 3}" @click="handleSearchType(3)">已签订合同</el-button>
                            </el-badge>
                            <el-badge :value="count4" style="margin-right: 25px;" :max="99" :hidden="form.custPageType == 4||count4==0">
                                <el-button size="mini" :class="{'selected':form.custPageType == 4}" @click="handleSearchType(4)">已成单</el-button>
                            </el-badge>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="4">
                    <template v-if="!!(typeof(actionData.customerwdkh_principal) != 'undefined'&&!actionData.customerwdkh_principal)">
                        <el-form inline label-width="90px" label-position="left" style="text-align: right;">
                            <el-form-item>
                                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="medium" icon="el-icon-plus" type="primary" @click="handleAdd">添加</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-col>
            </el-row>
        </div>
        <template v-if="!(typeof(actionData.customerwdkh_principal) != 'undefined'&&!actionData.customerwdkh_principal)">
            <el-form inline label-width="90px" label-position="left" style="padding: 20px 14px 0 14px;">
                    <el-form-item label="客户类型：">
                        <el-select size="medium" 
                            v-model="form.custType" 
                            placeholder="请选择"
                            @change="getOptionHeaders"
                        >
                            <el-option 
                                v-for="(item,index) in custTypeOption"
                                :value="item.key" 
                                :label="item.value"
                                :key="index"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="负责人：">
                        <el-select 
                            size="medium"
                            filterable
                            v-model="form.headerId" 
                            placeholder="请选择"
                        >
                            <el-option 
                                v-for="(item,index) in fzrList"
                                :label="item.userName" 
                                :value="item.userId"
                                :key="index"
                            >
                                <span style="float:left;min-width:3em;">{{ item.userName }}</span>
                                <span style="float:left;padding-left:10px;">{{ item.handset }}</span>
                                <span style="float:right;padding-left:10px;">{{ item.companyName }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-button style="" size="medium" icon="el-icon-plus" type="primary" @click="handleAdd">添加</el-button>
                </el-form-item>
            </el-form>
        </template>

         <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="570"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="企业名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.companyname" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span class="linkInfo" v-if="scope.row.companyname"  @click="linkCustomerInfoFun(scope.row.companyid,scope.row.custId)">{{scope.row.companyname}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系人">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.linkman" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.linkman || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="外部销售">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" 
                            placeholder="请选择"
                            filterable 
                            v-model="form.exterSalerId" 
                            style="width: 100%;"
                        >
                            <el-option 
                                v-for="(item,index) in ybxsList"
                                :label="item.userName" 
                                :value="item.userId"
                                :key="index"
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.exterSalerName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="外部销售公司">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.exterSalerCompanyName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.exterSalerCompanyName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- <el-table-column label="企业ID">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.companyid" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.companyid || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业类型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" 
                            placeholder="请选择" 
                            v-model="form.rolescode" 
                            style="width: 100%;"
                        >
                            <el-option
                                v-for="(item,index) in companyRolesList"
                                :value="item.rolescode" 
                                :label="item.rolesname"
                                :key="index"
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.rolesname || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业账号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.account" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.account || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
            <el-table-column label="地区">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="region" placeholder="请选择" @click.native="isRegionShow"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.provinceName">{{scope.row.provinceName}}{{scope.row.cityName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="最近跟进时间">
                <el-table-column show-overflow-tooltip  width="240">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.timeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        >
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.followTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            
            <el-table-column label="手机号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>

            <el-table-column label="用户级别">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.level" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in levelArr" 
                                :key="index"
                                :value="item.value" 
                                :label="item.value" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.level || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- <el-table-column label="下次跟进时间">
                <el-table-column show-overflow-tooltip width="240">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.nextTraceDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        >
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.nextFollowTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog 
            :visible.sync="areaShow" 
            title="地区" 
            width="34%" 
            ref="dialog"
            append-to-body
        >
            <el-form ref="area" label-width="60px" >
                <el-form-item label="地址：">
                    <el-select 
                        size="medium" 
                        value-key="aid"
                        v-model="regionForm.ProvinceId"
                        placeholder="省"
                        filterable
                        clearable
                        style="width: 48%;margin-right: 10px;"
                        @change="ProvinceIdFun"
                    >
                        <el-option 
                            v-for="(item, index) in ProvinceIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="aid" 
                        v-model="regionForm.CityId" 
                        placeholder="市" 
                        filterable 
                        clearable 
                        style="width: 48%;margin-right: 10px;" 
                    >
                        <el-option 
                            v-for="(item, index) in CityIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddressFun">确 定</el-button>
            </span>
        </el-dialog>
        <AddDialog ref="addCustomer" @onSubmit="confirmSeasAdd"/>
    </div>
</template>
<script>
    import {
        myCustList,   //客户列表
        optionHeaders,  //负责人
        myCustCount,    //客户角标
        myCustType,     //客户类型
        seasAdd,
    } from "@/service/customerInformation";
    import {
        companyRoles,       //企业类型
        optionsArea,        //省市区
    } from "@/service/area";
    import { 
        getStorageUserRoleId,
        getActionData
    } from '@/utils/store'
    import AddDialog from './index/addCustomerDialog'
    export default {
        components: {
            AddDialog
        },
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,

                    companyname: '',    //企业名称
                    companyid: '',      //企业id
                    rolescode: '',      //企业类型
                    account: '',        //企业账户
                    timeDate: [],       //跟进时间
                    phone: '',          //手机号
                    nextTraceDate:[],
                    custType: '',        //客户类型
                    headerId: '',       //负责人id

                    custPageType: 0,    //客户状态分类(0=全部，1=未注册，2=已注册，3=已签订合同，4=已成单) 

                    linkman: '',                    //联系人
                    exterSalerId: '',               //外部销售负责人id
                    exterSalerCompanyName: '',      //外部销售公司

                    level: '',

                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数

                custTypeOption: [],             //客户类型
                tableData:[],
                companyRolesList: [],           //企业类型
                fzrList: [],                    //负责人option
                levelArr: [
                    {
                        value: 'A'
                    },
                    {
                        value: 'B'
                    },
                    {
                        value: 'C'
                    }
                ],

                // 地区
                areaShow: false,
                region: '', 

                regionForm: {
                    ProvinceId: '', //省
                    CityId: '', //市
                },

                ProvinceIdList: [],
                CityIdList: [],

                // 角标
                count0: 0,
                count1: 0,
                count2: 0,
                count3: 0,
                count4: 0,

                ybxsList: [],       //外部销售负责人

            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.getCompanyRoles();
            this.getMyCustType();
            this.getExterSaler();
        },
        methods: {
            // 获取我的客户角标
            getMyCustCount(data){
                let row = JSON.parse(JSON.stringify(data))
                delete row.custPageType
                myCustCount(row).then(res=>{
                    res.Data.map(obj=> {
                        switch(obj.custPageType) {
                            case 0:
                                this.count0 = obj.count
                                break;
                            case 1:
                                this.count1 = obj.count
                                break;
                            case 2:
                                this.count2 = obj.count
                                break;
                            case 3:
                                this.count3 = obj.count
                                break;
                            default:
                                this.count4 = obj.count
                                break;
                        }

                    })
                    // console.log(res)
                })
            },
            // 获取客户类型
            getMyCustType(){
                myCustType().then(res=> {
                    this.custTypeOption = res.Data
                })
            },
            //企业类型
            getCompanyRoles(){
                companyRoles().then(res=> {
                    this.companyRolesList = res.Data
                })
            },
            // 分类
            handleSearchType(type){
                this.form.custPageType = type
                this.handleSearch()
            },
            // 获取负责人
            getOptionHeaders() {
                let data = {}
                data.headerType = this.form.custType
                this.form.headerId = ''
                optionHeaders(data).then(res=> {
                    this.fzrList = res.Data
                })
            },
            // 获取外部销售
            getExterSaler(){
                let data = {}
                data.headerType = 2
                optionHeaders(data).then(res=> {
                    this.ybxsList = res.Data
                })
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.regionForm = {
                    ProvinceId: '', //省
                    CityId: '', //市
                    XianId: '', //区
                }
                this.region = ''
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetmyCustList()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetmyCustList()
            },
            //获取我的客户列表
            async GetmyCustList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                // typeof(this.actionData.customerwdkh_principal) != 'undefined'&&
                if(!this.actionData.customerwdkh_principal && typeof(this.actionData.customerwdkh_principal) != 'undefined') {
                    data.headerId = getStorageUserRoleId()
                }
                data.rational = true
                !data.companyname && delete data.companyname
                !data.companyid && delete data.companyid
                !data.rolescode && delete data.rolescode
                !data.account && delete data.account
                !data.phone && delete data.phone
                data.provinceId = this.regionForm.ProvinceId.aid
                data.cityId = this.regionForm.CityId.aid
                !data.provinceId && delete data.provinceId
                !data.cityId && delete data.cityId
                if (data.timeDate && data.timeDate.length) {
                    data.startTime = data.timeDate[0] + ' 00:00:01'
                    data.endTime = data.timeDate[1] + ' 23:59:59'
                }
                if (data.nextTraceDate && data.nextTraceDate.length) {
                    data.nextStartTime = data.nextTraceDate[0] + ' 00:00:01'
                    data.nextEndTime = data.nextTraceDate[1] + ' 23:59:59'
                }
                delete data.timeDate
                !data.level && delete data.level
                let res = await myCustList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas
                this.total = res.Data.total
                this.getMyCustCount(data)
            },
             // 地区
            isRegionShow(){
                this.areaShow = true
                this.$nextTick(()=>{
                    this.getAreaDataByParentFun(0,1)
                })
            },
            // 点击省份
            ProvinceIdFun(){
                this.getAreaDataByParentFun(this.regionForm.ProvinceId.aid,2)
                this.regionForm.CityId = {aid : '',areaname: ''}
            },
            // 点击地址确定
            submitAddressFun(){
                if(this.regionForm.CityId.areaname) {
                    this.region = this.regionForm.ProvinceId.areaname + this.regionForm.CityId.areaname
                }else{
                    this.region = this.regionForm.ProvinceId.areaname 
                }
                this.areaShow = false
            },

            //获取地址
            async getAreaDataByParentFun(id,hier){
                let data = {
                    aid: id,
                    areaType: hier
                }
                let res = await optionsArea(data)
                    switch(hier){
                        case 1:
                            this.ProvinceIdList = res.Data
                            // console.log('省')
                            break;
                        default:
                            this.CityIdList = res.Data
                            // console.log('市')
                    }
            },
            // 跳转到客户信息
            linkCustomerInfoFun(id,custId) {
                this.$router.push('/customer/myCustomerInfo?companyId='+ id +'&custId='+custId)
            },
            //添加我的客户
            handleAdd(){
                this.$refs.addCustomer.open()
            },
            // 添加按钮
            confirmSeasAdd(val) {
                seasAdd(val).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('添加成功！')
                    this.$refs.addCustomer.editorClose()
                    this.GetmyCustList();
                })
            },
        }
    };
</script>
<style  lang="scss">
    .customer-tabs-mg {
        .el-tabs__header {
            margin: 0 0 15px !important;
        }
    }
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
    .linkInfo {
        cursor: pointer;
        &:hover {
            color: #409EFF;
        }
    }
</style>